module.exports = __webpack_public_path__ + "static/media/31.00f93916.jpg";